module.exports = __webpack_public_path__ + "img/HeiGIT_Logo_base02.25692d0a.svg";